import React from 'react'
import styles from './styles.module.scss'
import Variant from '../Variant'

function Counts({ countTitle, totalCountTitle, count, totalCount }) {
  return (
    <div className={styles.stats}>
      <div className={styles.countContainer}>
        <span className={styles.text}>{countTitle}</span>
        <Variant variation={count} />
      </div>
      <div className={styles.countContainer}>
        <span className={styles.text}>{totalCountTitle}</span>
        <Variant variation={totalCount} />
      </div>
    </div>
  )
}

export default Counts
